module.exports = __webpack_public_path__ + "static/media/activityTypePill-journal.45d91688.svg";